<template>
  <div class="channel-table">
    <el-table
      :data="dataInfo"
      border
      stripe
      max-height="800"
      :header-cell-style="{
        background: '#4c84ff',
        color: '#fff',
        height: '60px',
        textAlign: 'center'
      }"
    >
      <el-table-column
        prop="shop_name"
        label="店铺"
        align="center"
        fixed
        width="180"
      />
      <el-table-column label="推荐渠道">
        <el-table-column
          prop="A10"
          label="Leads数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="B11"
          label="上门量"
          align="center"
          width="115"
        />
        <el-table-column
          prop="C7"
          label="新签人数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="D7"
          label="新签总额"
          align="center"
          width="115"
        />
        <el-table-column label="新签率" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.A10 == 0
                ? "0%"
                : `${((scope.row.C7 / scope.row.A10) * 100).toFixed(2)}%`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="新签平均单笔金额" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.C7 == 0
                ? "0"
                : `${(scope.row.D7 / scope.row.C7).toFixed(2)}`
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="在线渠道">
        <el-table-column
          prop="A11"
          label="Leads数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="B12"
          label="上门量"
          align="center"
          width="115"
        />
        <el-table-column
          prop="C8"
          label="新签人数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="D8"
          label="新签总额"
          align="center"
          width="115"
        />
        <el-table-column label="新签率" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.A11 == 0
                ? "0%"
                : `${((scope.row.C8 / scope.row.A11) * 100).toFixed(2)}%`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="新签平均单笔金额" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.C8 == 0
                ? "0"
                : `${(scope.row.D8 / scope.row.C8).toFixed(2)}`
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="呼入渠道">
        <el-table-column
          prop="A12"
          label="Leads数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="B13"
          label="上门量"
          align="center"
          width="115"
        />
        <el-table-column
          prop="C9"
          label="新签人数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="D9"
          label="新签总额"
          align="center"
          width="115"
        />
        <el-table-column label="新签率" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.A12 == 0
                ? "0%"
                : `${((scope.row.C9 / scope.row.A12) * 100).toFixed(2)}%`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="新签平均单笔金额" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.C9 == 0
                ? "0"
                : `${(scope.row.D9 / scope.row.C9).toFixed(2)}`
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="拉访渠道">
        <el-table-column
          prop="A13"
          label="Leads数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="B14"
          label="上门量"
          align="center"
          width="115"
        />
        <el-table-column
          prop="C10"
          label="新签人数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="D10"
          label="新签总额"
          align="center"
          width="115"
        />
        <el-table-column label="新签率" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.A13 == 0
                ? "0%"
                : `${((scope.row.C10 / scope.row.A13) * 100).toFixed(2)}%`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="新签平均单笔金额" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.C10 == 0
                ? "0"
                : `${(scope.row.D10 / scope.row.C10).toFixed(2)}`
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="直访渠道">
        <el-table-column
          prop="A14"
          label="Leads数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="B15"
          label="上门量"
          align="center"
          width="115"
        />
        <el-table-column
          prop="C11"
          label="新签人数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="D11"
          label="新签总额"
          align="center"
          width="115"
        />
        <el-table-column label="新签率" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.A14 == 0
                ? "0%"
                : `${((scope.row.C11 / scope.row.A14) * 100).toFixed(2)}%`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="新签平均单笔金额" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.C11 == 0
                ? "0"
                : `${(scope.row.D11 / scope.row.C11).toFixed(2)}`
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="其他">
        <el-table-column
          prop="A15"
          label="Leads数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="B16"
          label="上门量"
          align="center"
          width="115"
        />
        <el-table-column
          prop="C12"
          label="新签人数"
          align="center"
          width="115"
        />
        <el-table-column
          prop="D12"
          label="新签总额"
          align="center"
          width="115"
        />
        <el-table-column label="新签率" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.A15 == 0
                ? "0%"
                : `${((scope.row.C12 / scope.row.A15) * 100).toFixed(2)}%`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="新签平均单笔金额" align="center" width="115">
          <template slot-scope="scope">
            <span>{{
              scope.row.C12 == 0
                ? "0"
                : `${(scope.row.D12 / scope.row.C12).toFixed(2)}`
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'ChannelTable',
  props: {
    dataInfo: Array
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.channel-table {
}
</style>
